import axios from 'axios';
import API from './API';


export const Status_Add = (data) => API.post('Status/Add', data);
export const Status_Get_All = () => {
  return API.get("Status/Get_All");
};
export const Status_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Status/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Status_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Status/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Status_Initialize = () => {
  const Token = localStorage.getItem("Token");
  return API.post(`Status/Initialize`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Status_Update = (data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Status/Update`, data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
